import v1_0 from './v1-0/v1-0.json';
import shared from './shared.json';
import utils from './shared';

export const STORI_v1_0 = v1_0;
export const STORI_shared = shared;
export const STORI_VERSIONS = [
	{
		label: '1.0',
		value: '1.0',
	},
];

export const STORI: { [key: string]: any } = {
	'1.0': STORI_v1_0,
	shared: STORI_shared,
};

export const STORI_UTILS = utils;

